<template>
  <div>
    <b-table
        head-row-variant="info"
        table-variant="white"
        :items="stockBasketList"
        :fields="stockBasketListHeaders"
        hover
        responsive
        :per-page="perPage"
        :busy="stockBasketListLoading"
        style="font-size:12px"
        show-empty
    >
      <template #empty="scope">
        <h6 class="text-center my-5">
          {{ scope.loading ? "Lütfen Bekleyin" : noStockMessage }}
        </h6>
      </template>
      <template #cell(dateRange)="data">
        {{ getDateRangeValue(data.item.startDate, data.item.finishDate) }}
      </template>
      <template #cell(currentType)="data">
        <v-chip>{{ getCurrentTypeValueText(data.item.currentType) }}</v-chip>
      </template>
      <template #cell(stockType)="data">
        <v-chip>{{ getStockTypeValueText(data.item.stockType) }}</v-chip>
      </template>
      <template #cell(valueKey1)="data">
        {{ getValueTypeText(data.item.valueType1) + data.item.valueKey1 }}
      </template>
      <template #cell(valueKey2)="data">
        {{ data.item.valueKey2 ? data.item.valueKey2 + getValueTypeText(data.item.valueType2) : "YOK"  }}
      </template>
      <template #cell(isActive)="data">
        <v-chip
            label
            outlined
            :color="
            data.item.isActive === true ? 'success darken-1' : 'secondary darken-1'
          "
        >{{ data.item.isActive === true ? "Aktif" : "Pasif" }}
        </v-chip
        >
      </template>
      <template #cell(process)="data">
        <div class="text-center">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="amber darken-2"
                  @click="openNewStockBasketDialog(data.item.id)"
              >
                <v-icon>mdi-pencil-outline</v-icon>
              </v-btn>
            </template>
            <span>Düzenle</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  color="danger darken-2"
                  @click="_stockBasketDelete(data.item.id)"
              >
                <v-icon>mdi-delete-outline</v-icon>
              </v-btn>
            </template>
            <span>Sil</span>
          </v-tooltip>
        </div>
      </template>
      <template #table-busy>
        <div class="text-center">
          <b-spinner
              variant="primary"
              size="lg"
              label="Text Centered"
          ></b-spinner>
        </div>
      </template>
    </b-table>
    <NewStockBasketDialog
        :showDialog="showNewStockBasketDialog"
        :processType="'edit'"
        :stockBasketId="stockBasketIdValue"
        @dialogChange="(e) => (showNewStockBasketDialog = e)"
        v-on:editdone="editdone"
    ></NewStockBasketDialog>
  </div>
</template>

<script>
import NewStockBasketDialog from "@/components/campaign/stocks/dialogs/NewStockBasketDialog";
import {mapState, mapActions} from "vuex";
import {formattedDate} from "@/momentHelper";


export default {
  components: {
    NewStockBasketDialog,
  },
  props: {
    perPage: {
      type: Number,
    },
    currentPage: {
      type: Number,
    },
  },

  computed: {
    ...mapState("basket", [
      "stockBasketList",
      "stockBasketListHeaders",
      "stockBasketListLoading",
        "noStockMessage",
    ]),
  },
  data() {
    return {
      showNewStockBasketDialog: false,
      stockBasketIdValue: null,
    };
  },
  methods: {
    ...mapActions("basket", ["stockBasketDelete"]),
    async _stockBasketDelete(id) {
      await this.stockBasketDelete({
        params: {
          campaignId: id,
        },
        body: {},
      })
    },
    getValueTypeText(value) {
      switch (value) {
        case 1:
          return "%"
        case 2:
          return " TL"
      }
    },
    getCurrentTypeValueText(value) {
      switch (value) {
        case 1:
          return "Tüm Cariler";
        case 2:
          return "Cari Kodu";
        case 3:
          return "Grup Kodu";
        case 4:
          return "Kod1 Kodu";
        case 5:
          return "Kod2 Kodu";
        case 6:
          return "Kod3 Kodu";
        case 7:
          return "Kod4 Kodu";
        case 8:
          return "Kod5 Kodu";
      }
    },
    getStockTypeValueText(value) {
      switch (value) {
        case 1:
          return "Tüm Stoklar";
        case 2:
          return "Stok Kodu";
        case 3:
          return "Grup Kodu";
        case 4:
          return "Kod1 Kodu";
        case 5:
          return "Kod2 Kodu";
        case 6:
          return "Kod3 Kodu";
        case 7:
          return "Kod4 Kodu";
        case 8:
          return "Kod5 Kodu";
      }
    },
    getDateRangeValue(value1, value2) {
      if (value2) {
        return formattedDate(value1) + " - " + formattedDate(value2);
      } else {
        return formattedDate(value1) + " - " + "\u221E";
      }
    },
    openNewStockBasketDialog(id) {
      this.stockBasketIdValue = id;
      this.showNewStockBasketDialog = true;
    },
    editdone() {
      this.$parent._fetchStockBasketList();
    }
  },
  watch: {},
};
</script>
